import socketIOClient from "socket.io-client";
import getEnvironment from "../constants/env";
const ws = socketIOClient(getEnvironment().REACT_APP_WEBSOCKET_URL, { transports: ['websocket'] });

export function emitWebSocketData(channel, data) {
  ws.emit(channel, JSON.stringify(data));
}
